import { slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useState, useMemo, useEffect } from 'react';
import { format } from 'date-fns';
import { Trigger, ModalDialog, Heading, Paragraph, Anchor, Text, List, TriggerText } from '@zillow/constellation';
import { BRANDING, getLegalDisclosureText, formatIntoDollars, getNationalConformingLoanLimits } from './constants.js';

var LegalDisclosuresModal = function LegalDisclosuresModal(_ref) {
  var classification = _ref.classification,
    rates = _ref.rates;
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    nationalConformingLoanLimits = _useState2[0],
    setNationalConformingLoanLimits = _useState2[1];
  var formatLimit = function formatLimit(limit) {
    return limit ? formatIntoDollars(limit) : '--';
  };
  var minLimit = formatLimit(nationalConformingLoanLimits.minLimit);
  var maxLimit = formatLimit(nationalConformingLoanLimits.maxLimit);
  var RATE_DETAILS_ID = 'LegalDisclosuresModal_rate_details';
  var refinance = classification.refinance;
  var lastUpdated = useMemo(function () {
    var rateData = Object.values(rates).find(function (_ref2) {
      var today = _ref2.today;
      return !!(today !== null && today !== void 0 && today.time);
    });
    if (rateData) {
      var date = new Date(rateData.today.time);
      return format(date, 'MM/dd/yyyy');
    }
    return null;
  }, [rates]);
  useEffect(function () {
    var loadLimits = function loadLimits() {
      return new Promise(function ($return, $error) {
        return Promise.resolve(getNationalConformingLoanLimits()).then(function ($await_1) {
          try {
            setNationalConformingLoanLimits($await_1);
            return $return();
          } catch ($boundEx) {
            return $error($boundEx);
          }
        }, $error);
      });
    };
    loadLimits();
  }, []);
  return /*#__PURE__*/React.createElement(Trigger, {
    triggered: function triggered(_ref3) {
      var isOpen = _ref3.isOpen,
        onClose = _ref3.onClose;
      return /*#__PURE__*/React.createElement(ModalDialog, {
        isOpen: isOpen,
        size: 'md',
        onClose: onClose,
        renderHeader: /*#__PURE__*/React.createElement(Heading, {
          level: "6"
        }, "Legal Disclosures"),
        renderBody: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Paragraph, {
          marginBottom: "sm"
        }, "Representative rates are based upon national or state specific averages from lenders quoting on Zillow for preliminary research purposes only. Actual available rates and monthly payment amounts are subject to market fluctuations and will depend on a number of factors, including geography and loan characteristics. Representative rates", ' ', lastUpdated && "are valid as of " + lastUpdated + " and", ' ', "assume a minimum credit score of 740 and loan-to-value ratio of 80%, except for FHA and VA loans which assume a minimum credit score of 680-739 and loan-to-value ratio of 96.5% and 100%, respectively. The Jumbo loan amount shown exceeds the highest conforming loan limit in most state or city locations for which rates are being provided. Currently, a Jumbo loan exceeds", ' ', minLimit, " for a single-family home in all states (except Hawaii and Alaska, and a few federally designated markets where the limit is", ' ', maxLimit, "). Estimated monthly payment amounts displayed are based upon principal and interest only, and taxes and insurance are not included in this estimate; the actual payment obligation may be greater. Not all borrowers will qualify for these rates. Final loan approval is subject to criteria established by a lender, including satisfactory appraisal, title review, and underwriting determination, among other criteria. Rates subject to change without notice. Restrictions apply.", ' ', /*#__PURE__*/React.createElement(Anchor, {
          href: "#" + RATE_DETAILS_ID
        }, "Click here to learn more details about the rates displayed.")), /*#__PURE__*/React.createElement(Paragraph, {
          marginBottom: "sm"
        }, "NOTE: Mortgage rate trends are based on historical rate data and the inputs that you select. Changes to inputs will affect the rate trends shown. Mortgage rate trends displayed are for informational purposes only and represent rate trends over time and are based upon national or state specific averages from lenders quoting on Zillow for preliminary research purposes only."), /*#__PURE__*/React.createElement(Paragraph, {
          marginBottom: "sm"
        }, "Mortgage rates are displayed through", ' ', BRANDING.ZGMI_FULL_NAME, " a licensed mortgage broker, ", BRANDING.ZGMI_NMLS_ID, ".", ' ', BRANDING.ZGMI_INC, " does not make loans and this is not a commitment to lend. See current list of state licenses and disclosures here. Please note: Adjustable-rate mortgages (ARMs) are loans with interest rates that change after an initial fixed-rate period."), /*#__PURE__*/React.createElement(Paragraph, {
          marginBottom: "sm"
        }, "ZGMI does not aid or assist consumers in obtaining loans, solicit consumers or lenders for loans, offer or negotiate terms of loans, make loans or credit decisions in connection with loans, take applications for credit, or issue pre-approval letters. ZGMI allows consumers to provide certain information to lenders. ZGMI does not guarantee that the loan terms or rates offered and made available by lenders are the best terms or lowest rates available in the market."), /*#__PURE__*/React.createElement(Text, {
          fontType: "h4",
          as: "h2",
          id: RATE_DETAILS_ID
        }, "More details about the rates displayed"), /*#__PURE__*/React.createElement(List, null, Object.entries(rates).filter(function (_ref4) {
          var _ref5 = _slicedToArray(_ref4, 2),
            today = _ref5[1].today;
          return !!today.apr;
        }).map(function (_ref6) {
          var _ref7 = _slicedToArray(_ref6, 2),
            loanType = _ref7[0],
            _ref7$ = _ref7[1],
            todayPayment = _ref7$.todayPayment,
            today = _ref7$.today,
            name = _ref7$.name;
          return /*#__PURE__*/React.createElement(List.Item, {
            key: loanType
          }, getLegalDisclosureText(todayPayment, today, name, refinance));
        })))
      });
    }
  }, /*#__PURE__*/React.createElement(Text, {
    fontType: "bodySmall"
  }, /*#__PURE__*/React.createElement(TriggerText, null, "See legal disclosures.")));
};
var LegalDisclosuresModal$1 = LegalDisclosuresModal;

export { LegalDisclosuresModal$1 as default };
